import React, { useEffect, useRef, useState } from "react";
import { VirtualKeyboard } from "commonComponents/VirtualKeyboard";
import { useForm } from "react-hook-form";
import { func } from "prop-types";
import { v4 as uuidv4 } from 'uuid';
import { getLocalStorage } from "utils";
import { USEVIRTUALKEYBOARD } from "utils/constants";
import { isNumber } from "utils/validator";
import { isMobileView } from "helper/commonHelpers";
import { useOnClickOutside } from "usehooks-ts";

export default function CommonInput(props) {
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [currInputField, setCurrInputField] = useState(null);
  const keyboard = useRef(null);
  const useVirutalKeyboard = JSON.parse(getLocalStorage(USEVIRTUALKEYBOARD)) || false;
  const [firstFocus, setFirstFocus] = useState(false);
  const [prevKeyboardState, setPrevKeyboardState] = useState(false);
  const [inputId, setInputId] = useState(uuidv4());
  const containerRef = useRef(null);
  const inputRef = props?.elementRef || props?.otherProps?.ref;
  const inputFieldId = props?.id || inputId;
  const containerClassName = props?.containerClassName || "w-full";

  useEffect(() => {
    function clickHanlder(e) {
      if (
        (e.target.id !== inputFieldId) &&
        !e.target.classList.contains("hg-button") &&
        !e.target.classList.contains("hg-row") &&
        !e.target.classList.contains("hg-rows") &&
        !e.target.classList.contains("draghere")
      ) {
        setPrevKeyboardState(showKeyboard);
        setShowKeyboard(false);
      }
    }

    window.addEventListener("click", clickHanlder);
    return window.removeEventListener("click", clickHanlder, true);
  }, []);

  function handleChange(event) {
    setFirstFocus(false);
    if (props?.onChange)
      props.onChange(event);
    else if (props?.otherProps?.onChange) {
      props?.otherProps?.onChange(event);
    }
    if (keyboard?.current?.setInput)
      keyboard.current.setInput(event.target.value);
  }

  function handleFocus(event) {
    setFirstFocus(true);
    if (event?.target?.nodeName === 'INPUT') {
      setCurrInputField(event.target);
    }
    if (props?.onFocus)
      props?.onFocus(event);
    else if (props?.otherProps?.onFocus) {
      props?.otherProps?.onFocus(event);
    }
    setPrevKeyboardState(showKeyboard);
  }

  function handleClickOutside() {
    if (props?.onBlur) {
      props?.onBlur();
      setShowKeyboard(false);
    }
  }

  useOnClickOutside(containerRef, handleClickOutside);

  function handleKeyboardOnChange(val) {
    if (props?.numberFlag && !isNumber(val)) {
      val = val?.slice(0, -1);
      if (props?.numberEmpty) val = "";
      if (keyboard?.current?.setInput)
        keyboard.current.setInput(val);
    }
    let newVal = val;
    setFirstFocus(false);
    setTimeout(() => {
      if (props?.onChange) {
        props?.onChange({ target: { value: newVal } })
        return;
      }
      if (currInputField) {
        setCurrInputField((prevVal) => {
          prevVal.value = newVal
          return prevVal
        })
      }
    }, 50)

    if (currInputField) {
      setCurrInputField((prevVal) => {
        prevVal.value = newVal
        return prevVal
      })
    }
  }

  return (
    <>
      <div className={containerClassName} ref={containerRef}>
        <input
          value={props.value}
          onFocus={(e) => handleFocus(e)}
          className={`${props?.className} ${props?.otherProps?.disabled ? 'pointer-events-none' : ''}`}
          onChange={(e) => handleChange(e)}
          onKeyDown={props.onKeyDown}
          placeholder={props?.placeholder}
          ref={inputRef}
          id={inputFieldId}
          onPaste={props?.onPaste}
          onWheel={event => event.currentTarget.blur()}
          {...props.otherProps}
          // Spreads only inputMode and pattern for numeric keyboard support, without overriding type
          inputMode={props?.isNumericInput ? 'numeric' : props?.otherProps?.inputMode}
          pattern={props?.isNumericInput ? '[0-9]*' : props?.otherProps?.pattern}
          type={props?.isNumericInput ? 'tel' : (props?.otherProps?.type || 'text')} // removed the otherProps as this flow will work
          /* 🔥 HARD OVERRIDES */
          autoComplete="off"
          autoCorrect="off"
          spellCheck={false}
          data-lpignore="true"
          data-form-type="other"
        ></input>

        {!isMobileView() && useVirutalKeyboard && showKeyboard && (
          <VirtualKeyboard
            handleenter={props?.handleEnter}
            initialVal={currInputField?.value}
            positionClass={props?.positionClass}
            keyboardclass={props?.keyboardclass}
            keyboardRef={keyboard}
            onChange={(val) => { handleKeyboardOnChange(val) }}
          />
        )}
      </div>
    </>
  )
}